import { render, staticRenderFns } from "./CreateDialogHeader.vue?vue&type=template&id=aa612f5e"
import script from "./CreateDialogHeader.ts?vue&type=script&lang=ts&external"
export * from "./CreateDialogHeader.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports